import { ButtonHTMLAttributes, FC } from "react";
import { To } from "react-router-dom";
import { StyledAnchorLink, StyledButton } from "./default.style";

type ButtonProps<type = "link" | "button"> = {
    as: type;
    to: type extends "link" ? To : never;
    onClick?(): void;
    children?: React.ReactNode;
    type?: ButtonHTMLAttributes<HTMLButtonElement>["type"];
    width?: string;
};

const Button: FC<ButtonProps> = ({ as, ...restProps }) =>
    as === "link" ? <StyledAnchorLink {...restProps} /> : <StyledButton {...restProps} />;

export default Button;
